module.exports = __webpack_public_path__ + "static/DariusB-c184da372459f77f3ae1b8f3b4cf0f49.gif";